export const pluralize = (count, noun, suffix = 's', suppressCount) =>
  `${suppressCount ? '' : count} ${noun}${count !== 1 ? suffix : ''}`
